import { Navigate, Outlet } from 'react-router-dom';

import { useAuthStatus } from 'hooks/useAuthStatus';
import { useSubscriptionAccess } from 'hooks/useSubscriptionAccess';
import { PATHS } from 'routes/paths';

export function ProtectedRoute({ redirectTo = PATHS.login }: { redirectTo?: string }) {
  const isAuthenticated = useAuthStatus();

  return isAuthenticated ? <Outlet /> : <Navigate to={redirectTo} replace />;
}

export function GuestRoute({ redirectTo = PATHS.account }: { redirectTo?: string }) {
  const isAuthenticated = useAuthStatus();

  return isAuthenticated ? <Navigate to={redirectTo} replace /> : <Outlet />;
}

export function SubscriptionRoute({ redirectTo = PATHS.pricing }: { redirectTo?: string }) {
  const isAuthenticated = useAuthStatus();
  const hasSubscriptionAccess = useSubscriptionAccess();

  if (!isAuthenticated) {
    return <Navigate to={PATHS.pricing} replace />;
  }

  return hasSubscriptionAccess ? <Outlet /> : <Navigate to={redirectTo} replace />;
}

export function PricingRoute({ redirectTo = PATHS.library }: { redirectTo?: string }) {
  const isAuthenticated = useAuthStatus();
  const hasSubscriptionAccess = useSubscriptionAccess();

  return isAuthenticated && hasSubscriptionAccess ? <Navigate to={redirectTo} replace /> : <Outlet />;
}
